// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".topic__comment__response-setting{font-size:12px;display:inline-block}.topic__comment__response-setting__body{white-space:nowrap}.topic__comment__response-setting__body>*{display:inline-block;vertical-align:text-bottom}", ""]);
// Exports
module.exports = exports;
